module.exports = __webpack_public_path__ + "static/media/4-8.6bd248a9.mp3";